//@ts-ignore
export default function (state: any, action: { type: string; payload?: { currencies: string[] } }) {
    if (!state) {
        state = [];
    }
    switch (action.type) {
        case 'COUNTRIES_LOAD':
            return state;
        case 'COUNTRIES_LOAD_DONE':
            return action.payload;
        default:
            return state;
    }
}
